import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';

import './ProductInfo.scss';

/**
 * Product information: Last updated time
 */

class ProductInfoComponent extends React.Component {
  getLastUpdatedText() {
    const isoDate = this.props.lastUpdated;
    if (isoDate) {
      // "Last saved: 1 min ago"
      const timeAgo = this.context.intl.formatRelative(isoDate);
      return (
        <FormattedMessage
          id="app.products.info.lastUpdated.timeAgo"
          defaultMessage="Last saved: {timeAgo}"
          values={{ timeAgo }}
        />
      );
    }
    return null;
  }

  render() {
    return <span className="product-info-component u-fontFamily-secondary">{this.getLastUpdatedText()}</span>;
  }
}

ProductInfoComponent.displayName = 'ProductInfo';

ProductInfoComponent.propTypes = {
  lastUpdated: PropTypes.string.isRequired,
};

ProductInfoComponent.contextTypes = {
  intl: intlShape.isRequired,
};

export default ProductInfoComponent;
